/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_Q_Fewer_FinalsInputs */



/**
* | output |
* | --- |
* | "Can I run finals with fewer than 5 players?" |
*
* @param {Og_Faq_Q_Fewer_FinalsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_q_fewer_finals = /** @type {((inputs?: Og_Faq_Q_Fewer_FinalsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_Q_Fewer_FinalsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Puis-je organiser une finale avec moins de 5 joueurs ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Puedo organizar finales con menos de 5 jugadores?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Posso realizar a final com menos de 5 jogadores?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posso giocare le finali con meno di 5 giocatori?")
	return /** @type {LocalizedString} */ ("Can I run finals with fewer than 5 players?")
});